import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusLabel',
  standalone: true,
})
export class StatusLabelPipe implements PipeTransform {
  private readonly bookingLabels: Record<string, string> = {
    new: 'Новый',
    confirmed: 'Подтверждён',
    cancelled: 'Отменён',
    completed: 'Завершён',
  };

  private readonly rentalLabels: Record<string, string> = {
    issued: 'Выдан',
    returned: 'Возвращён',
  };

  private readonly availabilityLabels: Record<string, string> = {
    free: 'Свободен',
    booked: 'Забронирован',
    rented: 'В прокате',
  };

  transform(value: string, type: 'booking' | 'rental' | 'availability' = 'booking'): string {
    switch (type) {
      case 'booking':
        return this.bookingLabels[value] || value;
      case 'rental':
        return this.rentalLabels[value] || value;
      case 'availability':
        return this.availabilityLabels[value] || value;
      default:
        return value;
    }
  }
}